import { devSiteKey, liveSiteKey, localSiteKey, testSiteKey, uatSiteKey } from '../../config/constants';
import { consentWorkFlowDomains, onboardingExitReviewsFlowDomains, recaptchaDomains } from '../constants/constants';

export const convertUTCtoLocal = (date: Date): string => {
    return new Date(date.toString()).toLocaleString('en-in', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
};

export function getSiteKey(): string {
    // Get the current domain
    const domain = window.location.hostname;
    let siteKey = '';
    if (domain === recaptchaDomains[0]) {
        siteKey = localSiteKey;
    } else if (domain === recaptchaDomains[1]) {
        siteKey = liveSiteKey;
    } else if (domain === recaptchaDomains[2]) {
        siteKey = testSiteKey;
    } else if (domain === recaptchaDomains[3]) {
        siteKey = devSiteKey;
    } else if (domain === recaptchaDomains[4]) {
        siteKey = uatSiteKey;
    } else {
        siteKey = devSiteKey;
    }
    return siteKey;
}

export function isConsentFeatureEnabled(consentWorkFlowSettings: any): boolean {
    // Get the current domain
    const domain = window.location.hostname;
    let featureEnabled = false;

    if (domain === consentWorkFlowDomains[0]) {
        featureEnabled = consentWorkFlowSettings?.settings?.isFeatureEnabled?.dev;
    } else if (domain === consentWorkFlowDomains[1]) {
        featureEnabled = consentWorkFlowSettings?.settings?.isFeatureEnabled?.prod;
    } else if (domain === consentWorkFlowDomains[2]) {
        featureEnabled = consentWorkFlowSettings?.settings?.isFeatureEnabled?.test;
    } else if (domain === consentWorkFlowDomains[3]) {
        featureEnabled = consentWorkFlowSettings?.settings?.isFeatureEnabled?.dev;
    } else if (domain === consentWorkFlowDomains[4]) {
        featureEnabled = consentWorkFlowSettings?.settings?.isFeatureEnabled?.uat;
    } else {
        featureEnabled = consentWorkFlowSettings?.settings?.isFeatureEnabled?.dev;
    }
    return featureEnabled;
}

export function isOnboardingAndExitReviewsFeatureEnabled(onboardingExitReviewFlowSettings: any): boolean {
    // Get the current domain
    const domain = window.location.hostname;
    let featureEnabled = false;

    if (domain === onboardingExitReviewsFlowDomains[0]) {
        featureEnabled = onboardingExitReviewFlowSettings?.settings?.isFeatureEnabled?.dev;
    } else if (domain === onboardingExitReviewsFlowDomains[1]) {
        featureEnabled = onboardingExitReviewFlowSettings?.settings?.isFeatureEnabled?.prod;
    } else if (domain === onboardingExitReviewsFlowDomains[2]) {
        featureEnabled = onboardingExitReviewFlowSettings?.settings?.isFeatureEnabled?.test;
    } else if (domain === onboardingExitReviewsFlowDomains[3]) {
        featureEnabled = onboardingExitReviewFlowSettings?.settings?.isFeatureEnabled?.dev;
    } else if (domain === onboardingExitReviewsFlowDomains[4]) {
        featureEnabled = onboardingExitReviewFlowSettings?.settings?.isFeatureEnabled?.uat;
    } else {
        featureEnabled = onboardingExitReviewFlowSettings?.settings?.isFeatureEnabled?.dev;
    }
    return featureEnabled;
}

export function isKYCDigioSignFeatureEnabled(kycDigioSignFlowSettings: any): boolean {
    // Get the current domain
    const domain = window.location.hostname;
    let featureEnabled = false;

    if (domain === onboardingExitReviewsFlowDomains[0]) {
        featureEnabled = kycDigioSignFlowSettings?.settings?.isFeatureEnabled?.dev;
    } else if (domain === onboardingExitReviewsFlowDomains[1]) {
        featureEnabled = kycDigioSignFlowSettings?.settings?.isFeatureEnabled?.prod;
    } else if (domain === onboardingExitReviewsFlowDomains[2]) {
        featureEnabled = kycDigioSignFlowSettings?.settings?.isFeatureEnabled?.test;
    } else if (domain === onboardingExitReviewsFlowDomains[3]) {
        featureEnabled = kycDigioSignFlowSettings?.settings?.isFeatureEnabled?.dev;
    } else if (domain === onboardingExitReviewsFlowDomains[4]) {
        featureEnabled = kycDigioSignFlowSettings?.settings?.isFeatureEnabled?.uat;
    } else {
        featureEnabled = kycDigioSignFlowSettings?.settings?.isFeatureEnabled?.dev;
    }
    return featureEnabled;
}
